import React from 'react';
import { InputText } from 'primereact/inputtext';
import { normalizeHourString } from '@utils/utils';

interface ComponentProps {
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  disabled?: boolean;
  dataTestId?: string;
  style?: React.CSSProperties;
}

const InputHourManual: React.FC<ComponentProps> = ({ onChange, value, disabled, readOnly, dataTestId, style }) => {
  const onBlur = () => {
    onChange(normalizeHourString(value));
  };

  const change = (time: string) => {
    if (time.match(/[0-9:]*/)[0] === time) {
      onChange(time);
    }
  };

  return (
    <>
      <InputText
        onChange={e => change(e.currentTarget.value)}
        value={value ?? ''}
        data-testid={dataTestId}
        readOnly={readOnly}
        disabled={disabled}
        style={style}
        onBlur={e => onBlur()}
        onKeyUp={event => {
          if (event.key === 'Enter') {
            onBlur();
          }
        }}
      />
    </>
  );
};

export default InputHourManual;
